module.exports = __webpack_public_path__ + "static/media/google.6ec65dbf.svg";